'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getCombox = getCombox;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getComponent = require('../layouts/getComponent');

var _layerConvertor = require('./layerConvertor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getCombox(_ref, findComponent) {
  var cname = _ref.cname,
      componentType = _ref.componentType,
      props = _ref.props,
      getProps = _ref.getProps,
      hoc = _ref.hoc,
      className = _ref.className;

  var Combox = function (_React$PureComponent) {
    _inherits(Combox, _React$PureComponent);

    function Combox(tprops, context) {
      _classCallCheck(this, Combox);

      var _this = _possibleConstructorReturn(this, (Combox.__proto__ || Object.getPrototypeOf(Combox)).call(this, tprops));

      var _getProps = _layerConvertor.converter.parse(getProps);
      var propsMap = _getProps ? _getProps.call(_this, tprops, context) : props || {};
      _this.state = {
        components: cname.map(function (n) {
          var item = propsMap[n];
          item.cname = item.cname || n;
          item.componentType = item.componentType || componentType;

          var Component = void 0;
          if (Array.isArray(item.cname)) {
            Component = getCombox(item, findComponent, function () {
              return Component.contextTypes;
            });
          } else {
            Component = findComponent(item) || _getComponent.getComponent.emptyComponent;
          }
          return {
            Component: Component,
            key: n
          };
        })
      };
      return _this;
    }

    _createClass(Combox, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(
          'div',
          { className: 'o-com-combox ' + (className || '') },
          this.state.components.map(function (item) {
            return _react2.default.createElement(item.Component, _extends({ key: item.key }, _this2.props));
          })
        );
      }
    }]);

    return Combox;
  }(_react2.default.PureComponent);

  if (hoc) {
    var Com = findComponent(hoc);
    if (!Com) {
      window.console.log('hoc组件丢失');
    }
    var ChildComponent = Combox;
    var childProps = hoc.childProps || {};

    var HocCombox = function (_React$PureComponent2) {
      _inherits(HocCombox, _React$PureComponent2);

      function HocCombox() {
        _classCallCheck(this, HocCombox);

        return _possibleConstructorReturn(this, (HocCombox.__proto__ || Object.getPrototypeOf(HocCombox)).apply(this, arguments));
      }

      _createClass(HocCombox, [{
        key: 'render',
        value: function render() {
          var children = _react2.default.createElement(
            Com,
            null,
            _react2.default.createElement(HocCombox.ChildComponent, _extends({}, childProps, this.props))
          );
          // #! 包裹
          var wrapper = _layerConvertor.converter.parse(hoc.wrapper);
          if (wrapper) {
            return wrapper(children);
          } else {
            return children;
          }
        }
      }]);

      return HocCombox;
    }(_react2.default.PureComponent);

    HocCombox.ChildComponent = ChildComponent;
    HocCombox._async = ChildComponent._async;

    return HocCombox;
  } else {
    return Combox;
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/layers/getCombox.jsx
// module id = 49
// module chunks = 0